import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = {
  key: 0,
  class: "my-1"
}
const _hoisted_4 = { class: "bg-gray-100 text-xs px-3 uppercase py-1 rounded-md" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  class: "text-sm font-medium font-montserrat w-auto text-black-lp-200",
  style: {"max-width":"296px"}
}
const _hoisted_7 = { class: "mb-2 flex items-center justify-between gap-x-5" }
const _hoisted_8 = { class: "font-semibold text-base text-black-lp-200" }
const _hoisted_9 = { class: "mb-2 flex flex-wrap gap-2" }
const _hoisted_10 = { class: "flex items-center justify-end flex-1" }
const _hoisted_11 = {
  key: 0,
  class: "flex gap-x-5 text-gray-lp-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list.slice(0, 2), (item) => {
        return (_openBlock(), _createBlock("div", { key: item }, [
          (_ctx.pillTitle)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("span", _hoisted_4, _toDisplayString(item), 1)
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(item), 1))
        ]))
      }), 128)),
      (_ctx.list.length > 2)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: "cursor-pointer text-sm text-blue-600 underline w-max font-semibold",
            tabindex: "0",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openOverlayPanel && _ctx.openOverlayPanel(...args)), ["stop"]))
          }, " Lihat lainnya "))
        : _createCommentVNode("", true),
      _createVNode(_component_OverlayPanel, {
        id: "card-popup-other-tag",
        ref: _ctx.opKey,
        appendTo: "body"
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("h3", _hoisted_8, _toDisplayString(_ctx.title), 1),
              _createVNode("button", {
                class: "cursor-pointer text-xl leading-none text-gray-lp-600 hover:text-black-lp-200",
                "aria-hidden": "true",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeOverlayPanel && _ctx.closeOverlayPanel(...args)))
              }, [
                _createVNode(_component_Icons, {
                  name: "close",
                  class: "w-4"
                })
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.renderList, (item) => {
                return (_openBlock(), _createBlock("span", {
                  key: item,
                  class: "rounded-full bg-gray-lp-200 px-1 text-10px font-medium"
                }, _toDisplayString(item), 1))
              }), 128))
            ]),
            _createVNode("div", _hoisted_10, [
              (_ctx.list.length > _ctx.limitRender)
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode("button", {
                      class: ["rounded-full p-2 opacity-50", {
                  'hover:text-black-lp-200': _ctx.page !== 1,
                  'cursor-not-allowed': _ctx.page === 1
                }],
                      disabled: _ctx.page === 1,
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPrev && _ctx.onPrev(...args)))
                    }, [
                      _createVNode(_component_Icons, {
                        name: "arrow-down",
                        class: "w-3",
                        style: {"transform":"rotate(90deg)"}
                      })
                    ], 10, ["disabled"]),
                    _createVNode("button", {
                      class: ["rounded-full p-2 opacity-50", {
                  'hover:text-black-lp-200': _ctx.page !== _ctx.totalPage,
                  'cursor-not-allowed': _ctx.page === _ctx.totalPage
                }],
                      disabled: _ctx.page === _ctx.totalPage,
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)))
                    }, [
                      _createVNode(_component_Icons, {
                        name: "arrow-up",
                        class: "w-3",
                        style: {"transform":"rotate(90deg)"}
                      })
                    ], 10, ["disabled"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 512)
    ])
  ]))
}